import { memo } from 'react'

import {
    Container,
    HistoryContainer,
    HistoryContainerTitle,
    LoaderContainer,
    Loader,
} from './location-picker-items-styles'
import LocationPickerHistoryItem from './location-picker-history-item'
import { useTranslation } from '../../../hooks/locale'
import { LocationPickerCommonProps, LocationPickerRenderedComponentAddedProps } from './types'

type LocationPickerItemsProps<T extends object = object> = LocationPickerCommonProps<T> &
    Pick<LocationPickerRenderedComponentAddedProps<T>, 'historyItems' | 'focusedItem' | 'setFocusedItem'>

const LocationPickerItems = <T extends object = object>({
    locationItems,
    onLocationItemSelect,
    historyItems,
    onHistoryItemSelect,
    showLocationItems,
    locationItemComponent: LocationItemComponent,
    getLocationItemKey,
    focusedItem,
    setFocusedItem,
    isLoading,
}: LocationPickerItemsProps<T>) => {
    const { t } = useTranslation()

    if (isLoading) {
        return (
            <LoaderContainer>
                <Loader />
            </LoaderContainer>
        )
    }

    if (!showLocationItems && historyItems.length > 0) {
        return (
            <HistoryContainer>
                <HistoryContainerTitle>{t('recentSearches')}</HistoryContainerTitle>
                <Container>
                    {historyItems.map(historyItem => (
                        <LocationPickerHistoryItem
                            key={historyItem._time}
                            historyItem={historyItem}
                            onSelect={onHistoryItemSelect}
                            isFocused={historyItem === focusedItem}
                            onFocus={setFocusedItem}
                        />
                    ))}
                </Container>
            </HistoryContainer>
        )
    }

    return showLocationItems ? (
        <Container>
            {locationItems.map(item => (
                <LocationItemComponent
                    key={getLocationItemKey(item)}
                    item={item}
                    onSelect={onLocationItemSelect}
                    isFocused={item === focusedItem}
                    onFocus={setFocusedItem}
                />
            ))}
        </Container>
    ) : null
}

export default memo(LocationPickerItems)
